
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/register/update-user-details",
      function () {
        return require("private-next-pages/user/register/update-user-details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/register/update-user-details"])
      });
    }
  